var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RenderLikert',_vm._b({attrs:{"options":_vm.data.settings.options,"rows":_vm.data.settings.rows,"columns":_vm.data.settings.columns}},'RenderLikert',{ title:_vm.data.name, body:_vm.data.body, editor: _vm.editor, theme: _vm.theme },false))}
var staticRenderFns = []

export { render, staticRenderFns }